// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  configId: __t.u32().primaryKey().name("config_id"),
  twinElevationOffsetM: __t.option(__t.f64()).name("twin_elevation_offset_m"),
  sceneYawOffsetDeg: __t.option(__t.f64()).name("scene_yaw_offset_deg"),
  autoTeleportPlayerToProjectOrigin: __t.option(__t.bool()).name("auto_teleport_player_to_project_origin"),
  clampDynamicTwinsToTerrain: __t.option(__t.bool()).name("clamp_dynamic_twins_to_terrain"),
  clampStaticTwinsToTerrain: __t.option(__t.bool()).name("clamp_static_twins_to_terrain"),
});
